export default function CStringH() {
  return <h2>C String H</h2>;
}
